
// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// import Swiper styles
import 'swiper/css';

const swiper = new Swiper('.swiper', {
  modules: [Navigation, Pagination, Autoplay], 
  loop: true,   
   loopAdditionalSlides: 1, 
   speed: 400,     
   resistanceRatio: 0, 
    touchReleaseOnEdges: false, 
    centeredSlides: false, 
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return `<span class="${className}"></span>`;
      },
  },
     autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },

    breakpoints: {
      0: {
        slidesPerView: 1.3, 
        spaceBetween: 0,
        freeMode: false, 
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 60,
      },
    }
});
